import React, { useEffect, useState } from "react";
import { Card, CardHeader, CardBody } from "shards-react";
import Chart from "../../utils/chart";
import styled from "styled-components";

const CardStartDate = styled.div`
  margin: 10px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  & .date-inputs {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    & input {
      margin: 0 10px;
      border: 1px solid #e1e5eb;
      padding: 0.4286rem 0.875rem;
      font-size: 0.6875rem;
      line-height: 1.5;
      border-radius: 0.25rem;
      color: #3d5170;
    }
  }
`;

const LabDataOverviewGraph = (props) => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    document.querySelector(`#chartReportLabData${props.device}`).innerHTML =
      '<canvas id="webvitalschart' +
      props.device +
      '" height="120" style="max-width:100% !important"></canvas>';

    const ctx = document.getElementById(`webvitalschart${props.device}`);

    const chartOptions = {
      ...{
        responsive: true,
        legend: {
          position: "top",
        },
        elements: {
          line: {
            // A higher value makes the line look skewed at this ratio.
            tension: 0.3,
          },
          point: {
            radius: 0,
          },
        },
        scales: {
          xAxes: [
            {
              scaleLabel: {
                display: true,
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                suggestedMin: 0,
                beginAtZero: true,
              },
            },
          ],
        },
        hover: {
          mode: "nearest",
          intersect: false,
        },
        tooltips: {
          custom: false,
          mode: "nearest",
          intersect: false,
        },
      },
      ...props.chartOptions,
    };

    let filtered = [];

    if (startDate || endDate) {
      props?.data?.scanDates?.forEach((item) => {
        if (startDate && endDate) {
          if (
            item.split("T")[0] >= `${startDate}` &&
            item.split("T")[0] <= `${endDate}`
          ) {
            filtered.push([
              `${item.slice(5, 16).split("-").join("/").split("T").join(" ")}`,
            ]);
          }
        }
        if (startDate && !endDate) {
          if (item.split("T")[0] >= `${startDate}`) {
            filtered.push([
              `${item.slice(5, 16).split("-").join("/").split("T").join(" ")}`,
            ]);
          }
        }
        if (!startDate && endDate) {
          if (item.split("T")[0] <= `${endDate}`) {
            filtered.push([
              `${item.slice(5, 16).split("-").join("/").split("T").join(" ")}`,
            ]);
          }
        }
      });
    }

    let scanDates = props.data.scanDates.map((item) => [
      `${item.slice(5, 16).split("-").join("/").split("T").join(" ")}`,
    ]);

    let monthlyData = {
      labels:
        startDate || endDate
          ? filtered.length
            ? filtered.map((item) => [
                item[0].slice(0, 5),
                item[0].slice(6, 11),
              ])
            : ["No Data", "No Data"]
          : scanDates.map((item) => [
              item[0].slice(0, 5),
              item[0].slice(6, 11),
            ]),
      datasets: [
        {
          label: "FCP",
          fill: "start",
          data: props.data ? props.data.fcp : [0],
          backgroundColor: "#a3d5ff",
          borderColor: "#0087F9",
          pointBackgroundColor: "#ffffff",
          pointHoverBackgroundColor: "#0087F9",
          borderWidth: 1,
          pointRadius: 0,
          pointHoverRadius: 3,
        },
        {
          label: "LCP",
          fill: "start",
          data: props.data ? props.data.lcp : [0],
          backgroundColor: "#bdffe1",
          borderColor: "#00b060",
          pointBackgroundColor: "#ffffff",
          pointHoverBackgroundColor: "#00b060",
          borderWidth: 1,
          pointRadius: 0,
          pointHoverRadius: 3,
        },
        {
          label: "SI",
          fill: "start",
          data: props.data ? props.data.si : [0],
          backgroundColor: "#a3fffc",
          borderColor: "#00cfc8",
          pointBackgroundColor: "#ffffff",
          pointHoverBackgroundColor: "#00cfc8",
          borderWidth: 1,
          pointRadius: 0,
          pointHoverRadius: 3,
        },
        {
          label: "TBT",
          fill: "start",
          data: props.data ? props.data.tbt / 1000 : [0],
          backgroundColor: "#fca7ab",
          borderColor: "#FB3640",
          pointBackgroundColor: "#ffffff",
          pointHoverBackgroundColor: "#FB3640",
          borderWidth: 1,
          pointRadius: 0,
          pointHoverRadius: 3,
        },
        {
          label: "CLS",
          fill: "start",
          data: props.data ? props.data.cls : [0],
          backgroundColor: "#ffbaa6",
          borderColor: "#F96E46",
          pointBackgroundColor: "#ffffff",
          pointHoverBackgroundColor: "#F96E46",
          borderWidth: 1,
          pointRadius: 0,
          pointHoverRadius: 3,
        },
      ],
    };

    /* eslint-disable no-unused-vars */
    var myChart = new Chart(ctx, {
      type: "LineWithLine",
      data: monthlyData,
      options: chartOptions,
    });
  }, [props.data, startDate, endDate]);

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };

  return (
    <Card small className="h-100">
      <CardHeader className="border-bottom">
        <h6 className="m-0">Lab Data {props.device} Overview</h6>
      </CardHeader>
      <CardBody className="pt-0">
        <CardStartDate>
          <div className="date-inputs">
            <div>
              <span>Start Date:</span>
              <input
                placeholder="Start Date"
                type={"date"}
                onChange={handleStartDateChange}
              />
            </div>
            <div>
              <span>End Date:</span>
              <input
                placeholder="End Date"
                type={"date"}
                onChange={handleEndDateChange}
              />
            </div>
          </div>
        </CardStartDate>
        <div id={`chartReportLabData${props.device}`}>
          <canvas
            id={`webvitalschart${props.device}`}
            height="120"
            style={{ maxWidth: "100% !important" }}
          />
        </div>
      </CardBody>
    </Card>
  );
};

export default LabDataOverviewGraph;
